document.addEventListener('DOMContentLoaded', function() {
  const checkboxes = document.querySelectorAll('#ProductVariants input[type="radio"]');
  if (checkboxes.length > 0) {
    checkboxes[0].checked = true
  }
  let selectedValue = null;
  let selectVal = null;
  
  var productBtn = document.getElementById('productBtn');
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      // Uncheck all checkboxes if the product has only one variant
      checkboxes.forEach(cb => {
        
        if (cb !== this) cb.checked = false;
         if (cb.checked) {
            selectedValue = cb.getAttribute('data-id');
           selectedPrice = cb.getAttribute('data-price');
           selectVal = cb.value;
           
        }
      });
      const sizeVariant = document.getElementById('size_variant');
      sizeVariant.textContent = selectedValue;
      const productPrice = document.getElementById('product-price');
      productPrice.textContent = selectedPrice;
      productBtn.setAttribute('data-product-id', selectVal);
    });
      if (checkbox.checked) {
            selectedValue = checkbox.getAttribute('data-id');
            selectVal = checkbox.value;
        }
  });
  if(selectedValue == "Default Title"){
        var productVariantsElement = document.getElementById('ProductVariants');
    if (productVariantsElement) {
        productVariantsElement.style.display = 'none';
    }
        var elements = document.querySelectorAll('.product_sizes');
        elements[0].style.display = 'none';
    
  }else{
        
    if (productBtn) {
        productBtn.setAttribute('data-product-id', selectVal);
    }
    document.getElementById('size_variant').textContent = selectedValue
    document.getElementById('product-price').textContent = selectedPrice
    
  }

  //contact page
  function updateHiddenInput() {
      const phone1 = document.getElementById('phone1').value || '';
      const phone2 = document.getElementById('phone2').value || '';
      const phone3 = document.getElementById('phone3').value || '';

      // Concatenate the values
      const phoneNumber = phone1 + phone2 + phone3;

      // Update the hidden input field
      document.getElementById('phoneNumber').value = phoneNumber;
    }

    // Get the number inputs
    const phoneInputs = document.querySelectorAll('#phone1, #phone2, #phone3');

    // Add event listeners to each number input
  if(phoneInputs.length > 0){
        phoneInputs.forEach(input => {
      input.addEventListener('change', updateHiddenInput);
    });
      updateHiddenInput();
  }


    // Initial update in case the form is pre-filled
  
});
//check list
document.addEventListener('DOMContentLoaded', function() {
     document.getElementById('productBtn').disabled = true;
  // Get references to the dropdown and all elements with class "textClass"
  const dropdown = document.getElementById('availableOption');
  const textElements = document.querySelectorAll('.checkTags');

  // Function to handle the change event
  function handleDropdownChange() {
    // Get the selected value from the dropdown
    const selectedValue = dropdown.value;
    
    // Initialize a flag to check if the value is found
    let found = false;

    // Iterate over each element with the class "textClass"
    textElements.forEach(function(element) {
      // Check if the selected value matches the text content of the element
      if (element.textContent.trim() === selectedValue) {
        found = true;
      document.getElementById('error_message').textContent = '';
        document.getElementById('productBtn').disabled = false;

      }
    });

    // Optional: Provide feedback if the value is not found
    if (!found) {
     document.getElementById('productBtn').disabled = true;
      document.getElementById('error_message').textContent = "We're sorry, this product is not registered for retail in your state";
    }else{
       document.getElementById('error_message').textContent = 'Woohoo! This product is registered for retail in your state!';
       
    }
  }

  // Attach the change event listener to the dropdown
  dropdown.addEventListener('change', handleDropdownChange);
});

//Accordian
document.addEventListener('DOMContentLoaded', () => {
  const headers = document.querySelectorAll('.accordion-header');
  
  headers.forEach(header => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const isActive = content.style.maxHeight;
      const activeElement = document.querySelector('.active')
      // Close all open panels
      document.querySelectorAll('.accordion-content').forEach(panel => {
        activeElement?.classList.remove('active')
        panel.style.maxHeight = null;
        panel.style.opacity = '0';
        panel.style.visibility = 'hidden';
      });

      // Open the clicked panel if it was not already open
      if (!isActive) {
        content.parentElement.classList.add('active')
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.opacity = '1';
        content.style.visibility = 'visible';
      }
    });
  });
});
//zoom functinality

$(document).ready(function() {
    var $container = $('.zoom-container');
    var $image = $('#zoom-image');

    $container.on('mousemove', function(e) {
        var offset = $container.offset();
        var x = e.pageX - offset.left;
        var y = e.pageY - offset.top;

        var scale = 1.5; // Zoom scale factor
        var width = $image.width();
        var height = $image.height();
        var xPos = (x / width) * 100;
        var yPos = (y / height) * 100;

        $image.css({
            'transform': 'scale(' + scale + ')',
            'transform-origin': xPos + '% ' + yPos + '%'
        });
    });

    $container.on('mouseleave', function() {
        $image.css('transform', 'scale(1)');
    });
});



//collection filter page
    // color filter

    // let radioRound = []
 let radioRound = ''
    $(document).ready(function() {
      
      // const params = new URLSearchParams(window.location.search);
      //   let lastSegment = params.get('gf_565705');
      //   console.log('lastSegment',lastSegment)
      // if(!lastSegment){
      //    lastSegment = params.get('gf_566264')?.toLowerCase();
      // }else{
      //   lastSegment = lastSegment.toLowerCase()
      // }
      //         console.log('lastSegment2',lastSegment)

      //   let collectionTags = $('.collectionTags').val();
      //   let tags = collectionTags.split(',');
      //   var elementsDiv = document.getElementById(lastSegment+'-section');
      //       console.log('lastSegment',elementsDiv,lastSegment)

      //   if(elementsDiv){
      //     var elementsDiv = document.getElementById(lastSegment+'-section');
      //     elementsDiv.style.display = 'flex';
      //     var door_section = document.getElementById('door_section');
      //     door_section.style.display = 'block';
          
      //     // let noWhitespace = lastSegment.replace(/\s+/g, '');
      //     var radioButton = document.getElementById(lastSegment);
      //     radioButton.checked = true;
      //     radioRound=lastSegment
      //   }
      //    let collectionHandle = $('.collectionHandle').val();
      //  $('.items-center').click(function () {
      //    localStorage.setItem('productFilterUrl', '');
      //   let radioVal =  $(this).find(".radio_round").val();
      //        // if(!radioRound.includes(radioVal)){
      //        //      radioRound.push(radioVal);
      //        //   }else{
      //        //      radioRound = radioRound.filter(item => item !== radioVal);
      //        //   }
      //        radioRound = radioVal
      //       if (radioRound && !tags.includes(radioRound)) {
      //             $('#showresults').html('<p class="align-centre"><em>Sorry, there are no products matching your search.</em></p>');
      //           $('#paginationDiv').html('');
      //         return;
      //       }
         
      //     // if(radioRound.length != 0){
      //     //   localStorage.setItem('radio_round_var', radioRound);
      //     //   if(radioRound.length == 1){
      //     //     var roundFilterVal = localStorage.getItem('radio_round_var')+"+";
      //     //   }else{
      //     //     const p = localStorage.getItem('radio_round_var');
      //     //     const regex = /,/gi;
      //     //     var roundFilterVal = p.replace(regex, '+')+"+";
      //     //   }
      //     // }else{
      //     //   var roundFilterVal = "";
      //     // }
    
      //     size_filter = [];
      //     localStorage.setItem('radio_round_var', "");
      //    if(tags.includes(lastSegment) && radioRound){
      //       filterUrl = "/collections/"+collectionHandle+'/'+radioRound;
      //    }else{
      //       filterUrl = collectionHandle+'/'+radioRound;
      //    }
      //     localStorage.setItem('productFilterUrl', filterUrl);
      //       console.log('filterUrl',filterUrl);
      //       getAjaxProducts(filterUrl)
      
      //   });
      // function getAjaxProducts(filterUrl) {
      //         $.ajax({
      //         url: filterUrl,
      //         data: {
      //           txtsearch: ''
      //         },
      //         type: "GET",
      //         dataType: "html",
      //         success: function (data) {
      //           let result = $('<div />').append(data).find('#showresults').html();
      //           $('#showresults').html(result);
      //           let resultPagination = $('<div />').append(data).find('#paginationDiv').html();
      //           if(resultPagination){
      //             $('#paginationDiv').html(resultPagination);
      //           }else{
      //             $('#paginationDiv').html('');
      //           }
                
      //         },
      //         error: function (xhr, status) {
      //           alert("Sorry, there was a problem!");
      //         },
      //         complete: function (xhr, status) {
      //         }
      //       });
      // }

        // Handle pagination button click
  $(document).on('click', '.paginationBtn', function() {
    var dataHref = $(this).data('href');
    let page = dataHref.split('?')[1]
    let pageUrl = localStorage.getItem('productFilterUrl') ;
    if(!pageUrl){
        pageUrl = $('.collectionHandle').val();
    }
    let finalUrl = pageUrl +'?'+ page;
    console.log('finalUrl',finalUrl)
    getAjaxProducts(finalUrl)
    });
      
      //contact page 
  function updateHiddenInput() {
    var phone1 = $('#phone1').val() || '';
    var phone2 = $('#phone2').val() || '';
    var phone3 = $('#phone3').val() || '';

    // Concatenate the values
    var phoneNumber = phone1 + phone2 + phone3;

    // Update the hidden input field
    $('#phoneNumber').val(phoneNumber);
  }

  // Function to restrict input to a maximum of 3 digits
  function restrictToThreeDigits(event) {
    var value = $(this).val();
     const fourhtInput = document.querySelector("#phone3");
      // for first two phone input only three digits are allowed
      if (value.length > 3 && this !== fourhtInput) {
        $(this).val(value.slice(0, 3));
      } else if (this === fourhtInput && value.length > 4) {
        // for first last phone input only four digits are allowed
        $(this).val(value.slice(0, 4));
      }
     
      
  }

  // Bind event handlers to number inputs
  $('#phone1, #phone2, #phone3').on('input change', function() {
    restrictToThreeDigits.call(this);
    updateHiddenInput();
  });

  // Initial update in case the form is pre-filled
  updateHiddenInput();

      });
        //delte



// drawer
document.addEventListener('DOMContentLoaded', function() {
  var drawer = document.getElementById('add-to-cart-drawer');
  var closeButton = document.querySelector('.drawer-close');
  
  function openDrawer() {
    drawer.classList.add('open');
  }
  
  function closeDrawer() {
    drawer.classList.remove('open');
  }
  
  closeButton.addEventListener('click', closeDrawer);
  
  document.addEventListener('click', function(event) {
    if (!drawer.contains(event.target) && !event.target.matches('.drawer-toggle')) {
      closeDrawer();
    }
  });

  document.querySelectorAll('.add-to-cart-button').forEach(function(button) {
    button.addEventListener('click', function() {
      // Add product to cart
      addToCart(button.dataset.productId);
    });
  });

  function addToCart(productId) {
    var quantity = 1; // Default quantity
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: productId, quantity: quantity }] })
    })
    .then(response => response.json())
    .then(data => {
      openDrawer();
      updateCartDrawer();
    });
  }

  function updateCartDrawer() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        var cartItemsContainer = document.getElementById('cart-items');
        cartItemsContainer.innerHTML = ''; // Clear previous items
        console.log('cartcart',cart)
         var drawerBottom = document.getElementById('cartBottom');
        if(cart.item_count > 0){
          cart.items.forEach(item => {
            let variantTitle = item.variant_title != null ? ' '+item.variant_title : '';
            var itemElement = document.createElement('div');
            itemElement.className = 'cart-item';
            itemElement.innerHTML = '<div class="cart-popup-item"><div class="cart-popup-item__image-wrapper"><img src="'+ item.image +'"></div><div class="cart-popup-item__description"><div class="cart-popup-item__title">'+ item.product_title +''+ variantTitle +'</div><div class="shopify-buy__quantity-container clearfix" data-element="lineItem.quantity"><button type="button" data-id="'+ item.id +'" class="subcat_qun">-</button><input type="tel" data-id="'+ item.id +'" id="update_'+ item.key +'" value="' + item.quantity + '" min="0"  class="quanty cartQty-'+ item.id +'"><button type="button" data-id="'+ item.id +'" class="addcat_qu">+</button></div><div class="cart-popup-price">'+theme.Currency.formatMoney(item.final_line_price, theme.settings.moneyFormat) +'</div></div></div>';
            cartItemsContainer.appendChild(itemElement);
            
          });
          var drawer = document.getElementById('subTotal');
          drawerBottom.style.display = 'flex';
          drawer.textContent = theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat)
        }else{
          var itemElement = document.createElement('div');
            itemElement.className = 'cart-item';
            itemElement.innerHTML = '<p>Your cart is empty.</p>';
            cartItemsContainer.appendChild(itemElement);
            drawerBottom.style.display = 'none';
        }       
      });
  }

  function updateQuantity(line, change) {
    var data = { updates: {} };
    data.updates[line] = change;
    
    console.log('updateQuantity',line, change)
    // fetch('/cart/update.js', {
    //   method: 'POST',
    //   dataType: 'json',
    //   body: JSON.stringify(data)
    // })
      jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function() { 
            updateCartDrawer();
          },
    });
  }

  function removeItem(line) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(response => response.json())
    .then(data => {
      updateCartDrawer();
    });
  }
$(document).ready(function() {
   console.log('document','fieldName');
    $(document).on('click', '.addcat_qu', function(e){
 
    e.preventDefault();
    // alert("fdg");
    var fieldName = $(this).attr('data-id');
    // Get its current value
    var currentVal = parseInt($('.cartQty-'+fieldName).val());
    console.log('fieldName',fieldName);
    console.log(currentVal);
    if (!isNaN(currentVal)) {
      // Increment
      $('.cartQty-'+fieldName).val(currentVal + 1);
      updateQuantity(fieldName,currentVal + 1)
      $(this).prop('disabled', true);
    } else {
      // Otherwise put a 0 there
      $('.cartQty-'+fieldName).val(0);
       $(this).prop('disabled', true);
       updateQuantity(fieldName,0)
    }
  });
  // This button will decrement the value till 0
  $(document).on('click', '.subcat_qun', function(e){
    // alert("fdg");
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    var fieldName = $(this).attr('data-id');
    // Get its current value
    var currentVal = parseInt($('.cartQty-'+fieldName).val());
    if (!isNaN(currentVal) && currentVal > 1) {
      $('.cartQty-'+fieldName).val(currentVal - 1);
       updateQuantity(fieldName,currentVal - 1)
      $(this).prop('disabled', true);
    } else {
      $('.cartQty-'+fieldName).val(1);
       updateQuantity(fieldName,0)
      $(this).prop('disabled', true);
    }
  });

  
  
  $(document).on('change', '.quanty', function(e){
    e.preventDefault();
    // alert("fdg");
    var fieldName = $(this).attr('data-id');
    // Get its current value
    var currentVal = parseInt($(this).val());
    //console.log(fieldName);
    console.log('quanty',currentVal);
    if (!isNaN(currentVal)) {
      // Increment
      $('.cartQty-'+fieldName).val(currentVal);
      updateQuantity(fieldName,currentVal)
    } else {
      // Otherwise put a 0 there
      updateQuantity(fieldName,0)
      $('.cartQty-'+fieldName).val(0);
    }
  });

    $(document).on('click', '.draawerOpen', function(e){
      updateCartDrawer();
      openDrawer();
    });
});
});







